import React, { Component, PropTypes } from 'react';
import { reduxForm } from 'redux-form';
import validate from './validate';
import { browserHistory } from 'react-router';
import { saveCurrentRoute } from '../../util/routeHelper';
import { getAddressChangeStatus } from '../../address/actions/addressActions';


class BookingWizardConfirmDetails extends Component {

    constructor(props) {
        super(props);
    }

    handleNo() {
        let {jobId} = this.props.routeParams;
        saveCurrentRoute(this.props.location.pathname);

        if (this.props.allowAddressUpdate && !this.props.booking.details.isrefpfsDepot)
            browserHistory.push(`/booking/${jobId}/updateAddress`);
        else
            browserHistory.push(`/contactus/incorrectdetails/${jobId}`);
    }

    render() {
        const { onSubmit, previousPage, pristine, submitting, booking: { details } } = this.props;

        const { hasPendingPrimaryAddress, hasPendingDeliveryAddress, hasPendingChanges } = getAddressChangeStatus({ details });                             
        
        return (
            <div>
                <h2 className="client-text">Do we have the correct contact details?</h2>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card no-bottom text-center">
                            <i className="fa fa-user" /> <strong>{details.contact}</strong><br />
                            <i className="fa fa-phone" /> {details.phoneNumber}
                        </div>
                    </div>
                </div>
                <h2 className="client-text">Do we have the correct address?</h2>
                <div className="row">
                    <div className="col-md-12">
                        {details.deliveryInfo ? (
                            <h4 className="text-center m-t-5">Business Address</h4>
                        ) : details.isrefpfsDepot ? (
                            <h4 className="text-center m-t-5">Delivery Address</h4>
                        ) : null}
                        <div className="card text-center">
                            {hasPendingPrimaryAddress ? ( 
                                <div className="alert alert-info" role="alert">These details are pending approval!</div>
                            ) : null}
                            <address>
                                <i className="fa fa-map-marker" /> <strong>{details.name}</strong><br />
                                {details.address}<br />
                                {(details.address2 || "").trim() ? (
                                    <span>{details.address2}<br /></span>
                                ) : null}
                                {details.city}, {details.state}, {details.postcode}
                            </address>
                        </div>
                        {details.deliveryInfo ? (
                            <div>
                                <h4 className="text-center">Delivery Address</h4>
                                <div className="card text-center">
                                    {hasPendingDeliveryAddress ? ( 
                                        <div className="alert alert-info" role="alert">These details are pending approval!</div>
                                    ) : null}
                                    <address>
                                        <i className="fa fa-map-marker" /> <strong>{details.deliveryInfo.deliveryContact}</strong><br />
                                        {details.deliveryInfo.deliveryAddress}<br />
                                        {(details.deliveryInfo.deliveryAddress2 || "").trim() ? (
                                            <span>{details.deliveryInfo.deliveryAddress2}<br /></span>
                                        ) : null}
                                        {details.deliveryInfo.deliveryCity}, {details.deliveryInfo.deliveryState}, {details.deliveryInfo.deliveryPostcode}
                                    </address>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
                {hasPendingChanges ? (
                    <div className="alert alert-warning text-center" role="alert">
                        <p>You have pending address changes, these must be approved before you can book this job.</p>
                        <p><b>We will let you know once your changes have been approved.</b></p>
                    </div>
                ) : null}
                {details.isrefpfsDepot && !hasPendingChanges ? (
                    <h2 className="client-text m-t-0 m-b-20">Do you want to proceed with your booking?</h2>
                ) : null}
                <div className="row">
                    <div className={"col-xs-6" + (hasPendingChanges ? " hide" : "")}>
                        <button type="button" className="btn btn-client btn-lg btn-block" onClick={onSubmit}>
                            {details.isrefpfsDepot ? "Book" : "Yes"}
                        </button>
                    </div>
                    <div className={(hasPendingChanges ? "col-xs-12" : "col-xs-6")}>
                        <button type="button" className={"btn btn-lg btn-block " + (hasPendingChanges ? "btn-client" : "btn-client-alt")} onClick={this.handleNo.bind(this)}>
                            {hasPendingChanges ? "Update My Details" : "No"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default reduxForm({
    form: 'bookingForm',
    destroyOnUnmount: false,
    validate
})(BookingWizardConfirmDetails);


// WEBPACK FOOTER //
// ./app/booking/components/bookingWizardConfirmDetails.js